import script from "./WalletMovementPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./WalletMovementPopup.vue?vue&type=script&setup=true&lang=js"

import "./WalletMovementPopup.vue?vue&type=style&index=0&id=393aff2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393aff2b"]])

export default __exports__